/* iter87.199.97 — Pro+ Billing Terms public page.

Standalone route at `/terms/pro-plus-billing`. Fetches the current
markdown from `/api/billing/paddle/terms` and renders it with the
shared `renderMarkdownBody` helper (also used by `/terms` and
`/privacy` — iter87.199.144 unification) so all three legal pages
share one visual style. */
import React, { useEffect, useState } from "react";
import { renderMarkdownBody } from "@/lib/simpleMarkdown";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ProPlusBillingTerms() {
    const [state, setState] = useState({ loading: true, error: null, md: "", version: "" });

    useEffect(() => {
        fetch(`${API}/api/billing/paddle/terms`)
            .then((r) => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
            .then((j) => setState({ loading: false, error: null, md: j.markdown, version: j.version }))
            .catch((e) => setState({ loading: false, error: e.message, md: "", version: "" }));
    }, []);

    return (
        <div className="min-h-screen bg-[#0a0a0a] text-white p-6" data-testid="pro-plus-billing-terms-page">
            <article className="max-w-3xl mx-auto space-y-4">
                {state.loading && (
                    <div className="text-white/60 text-sm">Loading terms…</div>
                )}
                {state.error && (
                    <div className="text-red-400 text-sm" data-testid="pro-plus-terms-error">
                        Could not load terms ({state.error}). Please try again or contact admin@tinycrewrivalries.com.
                    </div>
                )}
                {!state.loading && !state.error && renderMarkdownBody(state.md)}
                {!state.loading && !state.error && (
                    <div className="pt-6 mt-8 border-t border-white/10 text-xs text-white/40"
                         data-testid="pro-plus-terms-version">
                        Version {state.version}
                    </div>
                )}
            </article>
        </div>
    );
}
